const HOST_NAME = window.location.hostname;

export const environment =
    HOST_NAME === 'app.apimatic.io' ? 'https://dash.apimatic.io' : 'https://dash.dev.apimatic.io';

export const PricingURL =
    HOST_NAME === 'app.apimatic.io'
        ? 'https://app.apimatic.io/pricing-plans'
        : 'https://app.dev.apimatic.io/pricing-plans';
